// src/firebase/auth.ts
import {
  getAuth,
  setPersistence,
  browserLocalPersistence,
  browserSessionPersistence,
  signInWithEmailAndPassword,
  signInWithPopup,
  GoogleAuthProvider,
  signOut,
  onAuthStateChanged,
  type User,
} from "firebase/auth";
import { app } from "./app"; // Asegúrate de exportar tu Firebase app desde aquí

export const auth = getAuth(app);

/** Nos aseguramos de fijar la persistencia UNA sola vez por sesión de JS */
let persistenceReady: Promise<void> | null = null;

export function setupAuthPersistence(): Promise<void> {
  if (!persistenceReady) {
    persistenceReady = setPersistence(auth, browserLocalPersistence).catch(
      async () => {
        // Fallback útil (Safari Modo Privado, 3rd-party cookies bloqueadas, etc.)
        await setPersistence(auth, browserSessionPersistence);
      }
    );
  }
  return persistenceReady;
}

export async function emailSignIn(email: string, password: string) {
  await setupAuthPersistence();
  return signInWithEmailAndPassword(auth, email, password);
}

export async function googleSignIn() {
  await setupAuthPersistence();
  const provider = new GoogleAuthProvider();
  provider.setCustomParameters({ prompt: "select_account" });
  return signInWithPopup(auth, provider);
}

export function signOutApp() {
  return signOut(auth);
}

/** Atajo para subscribirse al usuario */
export function onAuthChange(cb: (user: User | null) => void) {
  return onAuthStateChanged(auth, cb);
}

export async function forceRefreshIdToken(user?: User | null) {
  const u = user ?? auth.currentUser;
  if (!u) return;
  await u.getIdToken(true); // fuerza refresh de claims
  // opcional: await u.reload();
}
